import _ from 'lodash';
import { connect } from 'react-redux';
import {
  GenericDetailsView,
  GenericDetailsViewProps,
} from '../../../../modules/e-hub/components/GenericDetailsView';
import { put } from '../../../../stores';
import { DETAILS_VIEW_MOUNTED } from '../../actions/psAction';
import config from '../../package.json';
export class StressCareDetailsView extends GenericDetailsView {
  constructor(props: GenericDetailsViewProps) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
    put({
      type: DETAILS_VIEW_MOUNTED,
      payload: { ...this.props },
    });
  }
}

export default connect(
  StressCareDetailsView.mapStateToProps,
  StressCareDetailsView.mapDispatchToProps,
)(StressCareDetailsView);
